"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxField = void 0;
const react_1 = __importDefault(require("react"));
const CheckboxField = ({ field, value, onChange, error, disabled }) => (react_1.default.createElement("div", { className: "field-group" },
    react_1.default.createElement("div", { className: "checkbox-option" },
        react_1.default.createElement("input", { type: "checkbox", id: field.key, name: field.key, checked: !!value, onChange: (e) => onChange(field.key, e.target.checked), disabled: disabled }),
        react_1.default.createElement("label", { htmlFor: field.key },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required", style: { marginLeft: 4 } }, "*"))),
    error && react_1.default.createElement("div", { className: "field-error" }, error)));
exports.CheckboxField = CheckboxField;
